import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTIONS } from './types';
import { confirmCTA, goBack, toggleRadio } from './actions';
import { AssetRepositoryType, isDarkModeTheme } from '../../../configs/config';
import { heightMap } from '../../../configs/height';
let isDarkMode = isDarkModeTheme();
export const template = (assetRepository, hasCAMS, hasKARVY, hasMFCENTRAL, rtasCountAllowed, isCAMSRecommended, isKARVYRecommended, isMFCentralRecommended, subTitle) => {
    return {
        layout: {
            id: ROUTE.SELECT_SOURCE,
            type: LAYOUTS.MODAL,
            style: {
                height: rtasCountAllowed === 3
                    ? heightMap[ROUTE.SELECT_SOURCE_3]
                    : rtasCountAllowed === 2
                        ? heightMap[ROUTE.SELECT_SOURCE_2]
                        : rtasCountAllowed === 1
                            ? heightMap[ROUTE.SELECT_SOURCE_1]
                            : heightMap[ROUTE.SELECT_SOURCE],
            },
            widgets: [
                {
                    id: 'headerStack',
                    type: WIDGET.STACK,
                },
                // { id: "title", type: WIDGET.TEXT },
                { id: 'space1', type: WIDGET.SPACE },
                { id: 'subTitleStack', type: WIDGET.STACK },
                hasMFCENTRAL ? { id: 'space2', type: WIDGET.SPACE } : {},
                hasMFCENTRAL
                    ? { id: 'mfCentralMainStack', type: WIDGET.STACK }
                    : {},
                hasKARVY ? { id: 'space3', type: WIDGET.SPACE } : {},
                hasKARVY ? { id: 'kfinStack', type: WIDGET.STACK } : {},
                hasCAMS ? { id: 'space5', type: WIDGET.SPACE } : {},
                hasCAMS ? { id: 'camsStack', type: WIDGET.STACK } : {},
                { id: 'space4', type: WIDGET.SPACE },
                { id: 'continueButton', type: WIDGET.BUTTON },
                { id: 'subTitleSpace', type: WIDGET.SPACE },
            ],
        },
        datastore: {
            headerStack: {
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    { id: 'title', type: WIDGET.TEXT },
                    { id: 'leadIcon', type: WIDGET.BUTTON },
                ],
            },
            title: {
                label: 'Select source for MF portfolio',
                fontSize: FontSizeTokens.MD,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '700',
            },
            kFinTitle: {
                label: 'KFINTECH',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
            },
            mfCentralTitle: {
                label: 'MFCentral',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
            },
            camsTitle: {
                label: 'CAMS',
                fontSize: FontSizeTokens.SM,
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '600',
            },
            leadIcon: {
                id: 'bt_selectPortfolioScreen_cancel',
                label: '',
                type: ButtonTypeTokens.SmallGhost,
                width: ButtonWidthTypeToken.CONTENT,
                stack: {
                    type: StackType.row,
                    alignItems: StackAlignItems.flexStart,
                    justifyContent: StackJustifyContent.flexStart,
                },
                icon: {
                    name: IconTokens.Cancel,
                    align: IconAlignmentTokens.right,
                    size: IconSizeTokens.XXL,
                },
                action: {
                    type: ACTIONS.GO_BACK,
                    payload: {
                        value: '',
                        widgetId: 'input',
                        isResend: false,
                    },
                    routeId: ROUTE.SELECT_SOURCE,
                },
            },
            subTitleStack: {
                type: StackType.column,
                alignItems: StackAlignItems.flexStart,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [{ id: 'subTitle', type: WIDGET.TEXT }],
            },
            subTitle: {
                label: subTitle,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.SM,
            },
            subTitle2: {
                label: `records of mutual investments.`,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                fontSize: FontSizeTokens.XS,
            },
            camsStack: {
                id: 'rb_getPortfolioScreen_CAMS',
                width: StackWidth.FULL,
                type: StackType.row,
                justifyContent: StackJustifyContent.flexStart,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'camsRadio', type: WIDGET.ICON },
                    { id: 'camsSpace', type: WIDGET.SPACE },
                    { id: 'camsTitle', type: WIDGET.TEXT },
                    { id: 'spaceSize8', type: WIDGET.SPACE },
                    isCAMSRecommended
                        ? {
                            id: 'mfCentralRecommendedDC',
                            type: WIDGET.RECOMMENDED_ASSET_REPOSITORY,
                        }
                        : {},
                ],
                action: {
                    type: ACTIONS.TOGGLE_RADIO,
                    payload: {
                        value: AssetRepositoryType.CAMS,
                    },
                    routeId: ROUTE.SELECT_SOURCE,
                },
            },
            camsRadio: {
                name: assetRepository === AssetRepositoryType.CAMS
                    ? IconTokens.RadioCircleFilled
                    : IconTokens.RadioCircleNotFilled,
                size: IconSizeTokens.XL,
            },
            camsSpace: {
                size: SizeTypeTokens.MD,
            },
            camsIcon: {
                name: IconTokens.Cams,
                size: IconSizeTokens.XL,
            },
            space1: { size: SizeTypeTokens.MD },
            space2: { size: SizeTypeTokens.XXXL },
            space3: { size: SizeTypeTokens.SIZE18 },
            space5: { size: SizeTypeTokens.XXXL },
            kfinStack: {
                id: 'rb_getPortfolioScreen_KFINTECH',
                width: StackWidth.FULL,
                type: StackType.row,
                justifyContent: StackJustifyContent.flexStart,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'kfinRadio', type: WIDGET.ICON },
                    { id: 'kfinSpace', type: WIDGET.SPACE },
                    { id: 'kFinTitle', type: WIDGET.TEXT },
                    { id: 'spaceSize8', type: WIDGET.SPACE },
                    isKARVYRecommended
                        ? {
                            id: 'mfCentralRecommendedDC',
                            type: WIDGET.RECOMMENDED_ASSET_REPOSITORY,
                        }
                        : {},
                ],
                action: {
                    type: ACTIONS.TOGGLE_RADIO,
                    payload: {
                        value: AssetRepositoryType.KARVY,
                    },
                    routeId: ROUTE.SELECT_SOURCE,
                },
            },
            mfCentralMainStack: {
                width: StackWidth.FULL,
                type: StackType.column,
                widgetItems: [
                    { id: 'mfCentralStack', type: WIDGET.STACK },
                    { id: 'spaceSize4', type: WIDGET.SPACE },
                    { id: 'mfCentralDescriptionStack', type: WIDGET.STACK },
                ],
                action: {
                    type: ACTIONS.TOGGLE_RADIO,
                    payload: {
                        value: AssetRepositoryType.MFCENTRAL,
                    },
                    routeId: ROUTE.SELECT_SOURCE,
                },
            },
            mfCentralDescriptionStack: {
                type: StackType.row,
                padding: {
                    bottom: SizeTypeTokens.NONE
                },
                widgetItems: [
                    { id: 'mfCentralDescriptionSpace', type: WIDGET.SPACE },
                    { id: 'mfCentralDescription', type: WIDGET.TEXT },
                ],
            },
            mfCentralDescriptionSpace: {
                size: SizeTypeTokens.SIZE_26,
            },
            mfCentralDescription: {
                label: 'Fetch your complete portfolio with just one OTP',
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 0,
                fontSize: FontSizeTokens.XS,
            },
            mfCentralRecommendedDC: {
                height: 600,
            },
            mfCentralStack: {
                id: 'rb_getPortfolioScreen_MFCENTRAL',
                width: StackWidth.FULL,
                type: StackType.row,
                justifyContent: StackJustifyContent.flexStart,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: 'mfCentralRadio', type: WIDGET.ICON },
                    { id: 'kfinSpace', type: WIDGET.SPACE },
                    { id: 'mfCentralTitle', type: WIDGET.TEXT },
                    { id: 'spaceSize8', type: WIDGET.SPACE },
                    isMFCentralRecommended
                        ? {
                            id: 'mfCentralRecommendedDC',
                            type: WIDGET.RECOMMENDED_ASSET_REPOSITORY,
                        }
                        : {},
                ],
            },
            kfinRadio: {
                name: assetRepository === AssetRepositoryType.KARVY
                    ? IconTokens.RadioCircleFilled
                    : IconTokens.RadioCircleNotFilled,
                size: IconSizeTokens.XL,
            },
            mfCentralRadio: {
                name: assetRepository === AssetRepositoryType.MFCENTRAL
                    ? IconTokens.RadioCircleFilled
                    : IconTokens.RadioCircleNotFilled,
                size: IconSizeTokens.XL,
            },
            kfinSpace: {
                size: SizeTypeTokens.MD,
            },
            kfinIcon: {
                name: IconTokens.Kfin,
                size: IconSizeTokens.XL,
            },
            space4: { size: SizeTypeTokens.XXXL },
            continueButton: {
                id: 'bt_getPortfolioScreen_confirm',
                label: 'Confirm',
                width: ButtonWidthTypeToken.FULL,
                paddingVertical: SizeTypeTokens.MD,
                paddingHorizontal: SizeTypeTokens.MD,
                fontSize: FontSizeTokens.SM,
                action: {
                    type: ACTIONS.CONFIRM,
                    payload: {
                        assetRepository: assetRepository,
                    },
                    routeId: ROUTE.SELECT_SOURCE,
                },
                type: ButtonTypeTokens.LargeFilled,
                fontFamily: FontFamilyTokens.Inter,
                lineHeight: SizeTypeTokens.XXL,
                fontWeight: '700',
            },
            spaceSize8: {
                size: SizeTypeTokens.MD,
            },
            spaceSize4: {
                size: SizeTypeTokens.SM,
            },
        },
    };
};
export const selectSourceMF = {
    onLoad: async ({ network }, { selectedRepo, assetRepositoryMap }) => {
        const assetRepository = selectedRepo;
        console.warn('ASSET REPO RECEIVED IS ', assetRepository);
        const hasCAMS = assetRepositoryMap?.some(item => item?.assetRepository === 'CAMS');
        const hasKARVY = assetRepositoryMap?.some(item => item?.assetRepository === 'KARVY');
        const hasMFCENTRAL = assetRepositoryMap?.some(item => item?.assetRepository === 'MFCENTRAL');
        const isCAMSRecommended = assetRepositoryMap?.some(repository => repository?.assetRepository === 'CAMS' &&
            repository?.recommendedRta === true);
        const isKARVYRecommended = assetRepositoryMap?.some(repository => repository?.assetRepository === 'KARVY' &&
            repository?.recommendedRta === true);
        const isMFCentralRecommended = assetRepositoryMap?.some(repository => repository?.assetRepository === 'MFCENTRAL' &&
            repository?.recommendedRta === true);
        let subTitle = '';
        const entities = [];
        if (hasMFCENTRAL)
            entities.push('MFCentral');
        if (hasKARVY)
            entities.push('KFintech');
        if (hasCAMS)
            entities.push('CAMS');
        if (entities.length > 0) {
            const entitiesList = entities.length === 3
                ? `${entities[0]}, ${entities[1]} & ${entities[2]}`
                : entities.join(' & ');
            subTitle = `${entitiesList} ${entities.length > 1 ? 'are' : 'is'} SEBI regulated entit${entities.length > 1 ? 'ies' : 'y'} which maintain records of mutual investments.`;
        }
        const rtasCountAllowed = [hasCAMS, hasKARVY, hasMFCENTRAL].filter(Boolean).length;
        return Promise.resolve(template(assetRepository, hasCAMS, hasKARVY, hasMFCENTRAL, rtasCountAllowed, isCAMSRecommended, isKARVYRecommended, isMFCentralRecommended, subTitle));
    },
    actions: {
        [ACTIONS.GO_BACK]: goBack,
        [ACTIONS.TOGGLE_RADIO]: toggleRadio,
        [ACTIONS.CONFIRM]: confirmCTA,
    },
    clearPrevious: true,
};
